import React, { forwardRef } from 'react';
import cn from 'classnames';
import {
  Mark,
  MarkContainer,
  RadioContainer,
  RadioInput,
  RadioText
} from './styled';
import { NewRadioButtonProps } from './types';

export const NewRadioButton = forwardRef<HTMLDivElement, NewRadioButtonProps>(
  (
    {
      data,
      name,
      color,
      stat,
      cypress,
      currentValue,
      onChangeHandler,
      containerClassNames,
      additionalClasses,
      markerPosition = 'right',
      isSelected
    },
    ref
  ) => {
    const classes = cn(containerClassNames, additionalClasses);
    const isChecked = isSelected || currentValue === data.id;

    return (
      <RadioContainer
        ref={ref}
        className={classes}
        data-cy="radio-container"
        data-stat={stat}
        markerPosition={markerPosition}
      >
        <RadioInput
          type="radio"
          name={name}
          value={data.id}
          onChange={onChangeHandler}
          data-cy={`${cypress}-${data.id}`}
          checked={isChecked}
        />
        <RadioText
          tag="body_2"
          color={color}
          $isChecked={isChecked}
          data-cy={cypress}
        >
          {data.name}
        </RadioText>
        <MarkContainer>
          <Mark />
        </MarkContainer>
      </RadioContainer>
    );
  }
);

NewRadioButton.displayName = 'NewRadioButton';
